// ======================================================================
// File: src/modules/ppe/fms/pages/FollowupPage.jsx
// Purpose: Main container for Followup List
// Patterned after GRNListPage.jsx
// ======================================================================

import React from "react";
import FollowupList from "../components/followups/FollowupList";

export default function FollowupPage() {
  return <FollowupList />;
}
